import React from "react";
import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";

const DropdownMenu = ({ 
  trigger, 
  items = [], 
  placement = "bottom-end",
  disabled = false,
  className = ""
}) => {
  const getPlacementClasses = () => {
    switch (placement) {
      case "bottom-start":
        return "left-0 mt-2";
      case "bottom-end":
        return "right-0 mt-2";
      case "top-start":
        return "left-0 mb-2 bottom-full";
      case "top-end":
        return "right-0 mb-2 bottom-full";
      default:
        return "right-0 mt-2";
    }
  };

  return (
    <Menu as="div" className={`relative inline-block text-left ${className}`}>
      <div>
        <Menu.Button disabled={disabled} className="disabled:opacity-50 disabled:cursor-not-allowed">
          {trigger}
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items 
          className={`absolute z-10 w-40 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none ${getPlacementClasses()}`}
        >
          <div className="py-1">
            {items.map((item, index) => (
              <Menu.Item key={index}>
                {({ active }) => (
                  <button
                    onClick={item.onClick}
                    disabled={item.disabled}
                    className={`${
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                    } group flex w-full items-center px-4 py-2 text-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed`}
                  >
                    {item.icon && (
                      <item.icon
                        className="mr-3 h-4 w-4 text-gray-400 group-hover:text-gray-500"
                        aria-hidden="true"
                      />
                    )}
                    {item.label}
                  </button>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default DropdownMenu;

